import { ILink } from '@belong/types/links';
import { IPageAlert } from '@belong/types/alert';
import { FPageAlert } from '@belong/contentful';
import FGlobalSections, { IGlobalSections } from './sections';
import CategoryModel from './Categories';

export default class SiteConfig {
  public categories: CategoryModel = {} as CategoryModel;
  public sections: IGlobalSections = {} as IGlobalSections;
  public settings: Record<string, string | ILink> = {};
  public internetAlert?: IPageAlert;
  public mobileAlert?: IPageAlert;

  public async init(data: any): Promise<void> {
    const { rootCategory, categoryPageParentLink, breadcrumbsHomeLink, internetAlert, mobileAlert } = data;

    this.categories = new CategoryModel(rootCategory.fields);
    this.sections = await FGlobalSections(data);
    this.settings = {
      categoryPageParentLink,
      breadcrumbsHomeLink
    };
    this.mobileAlert = mobileAlert && FPageAlert(mobileAlert);
    this.internetAlert = internetAlert && FPageAlert(internetAlert);
  }
}
